var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('TitlePage'),_c('div',{staticClass:"faq"},[_c('b-container',{attrs:{"fluid":"md"}},[_c('div',{staticClass:"agents-invitation"},[_vm._v(" "+_vm._s(_vm.$t('agency.pageWillRedirect'))+" ")])])],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }